/**
 * @file 节流
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/throttle
 */
var DEFAULT_SHRESHHOLD = 250;
/**
 * 函数限流
 *
 * @function throttle
 * @param {Function} fn 需要做限流处理的函数
 * @param {number=} [threshhold=250] 限流时间阈值，单位毫秒，默认为 250
 * @param {*=} bind 针对 fn 最终调用时需要绑定的 this
 * @return {Function} 返回包装过带限流功能的 fn
 */

export default (function (fn) {
  var threshhold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SHRESHHOLD;
  var bind = arguments.length > 2 ? arguments[2] : undefined;
  var last;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var now = +new Date();

    var wrapper = function wrapper() {
      last = now;
      fn.apply(bind, args);
    };

    if (last && now < last + threshhold) {
      clearTimeout(timer);
      timer = setTimeout(wrapper, threshhold);
    } else {
      wrapper();
    }
  };
});